var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNestLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #2f70b2;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.94,14.78c-4.03,4.99-11.04,6.74-11.68,14.08-.16,1.79.76,2.38-1.49,1.31-6.57-3.14-1.64-12.32,3.51-14.88s7.68-2.96,11.89-7.3c.37-.38.84-1.69.75-.04-.13,2.32-1.56,5.06-2.99,6.83Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.2,14.72c.12.05,1.23,1.91,1.35,2.14,4.23,8.61-3.32,14.89-10.72,17.5-4.86,1.71-10.56,1.65-15.28-.49l3.39.04c8.39.47,21.39-6.3,21.44-15.98,0-.73-.46-2.74-.43-3,.02-.13.12-.27.26-.21Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.17,14.63c.11.13-.5,2.93-.53,3.48-.26,6.92,5.76,11.8,11.64,14.01.29.11,1.96.21.91.66-.44.19-2.99.13-3.61.08-8.26-.66-14.21-6.98-10.51-15.35.11-.25,1.79-3.24,2.1-2.87Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.41,29.78c-2.19,10.29-12.71,16.76-22.85,14.4-3.8-.88-7.79-3.12-10.04-6.3,4.97,3,11.46,4.01,16.64.92-.17-.05-.43.02-.62.04-3.04.41-4.67.92-7.87.51-4.36-.55-9.38-2.5-11.31-6.75-.39-.86-1.64-5.4-1.17-6.01.1-.13,1.41,2.39,1.6,2.67,3.77,5.45,13.64,8.89,20.06,7.9,6.5-1,12.65-5.16,15.15-11.32.09-.23.52-2.36.79-1.57.28.83-.18,4.47-.4,5.49Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.1,5.95c4.56,2.57.33,10.32-4.47,6.98-4.05-2.81-.31-9.67,4.47-6.98Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNestLogo);
export default __webpack_public_path__ + "static/media/NestLogo.a508a5593141072e24b30869077514af.svg";
export { ForwardRef as ReactComponent };